// One existing destination dialog, one native Shopify localization submission.
// Suggestions come from Shopify. A manual choice always wins; never interrupt a cart.
function keepCurrentPage(form) {
  let returnTo = form.elements.return_to;
  if (!returnTo) {
    returnTo = document.createElement('input');
    returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo);
  }
  returnTo.value = location.pathname + location.search + location.hash;
}
document.querySelectorAll('form[action$="/localization"]').forEach((form) => {
  form.addEventListener('submit', () => {
    keepCurrentPage(form);
    try {
      localStorage.setItem('glint-locale-choice', JSON.stringify({
        language: form.elements.language_code?.value || document.documentElement.lang,
        country: form.elements.country_code?.value || '',
        at: Date.now()
      }));
    } catch { /* The native form still works if browser storage is disabled. */ }
  });
});

(async function suggestInitialLocale() {
  const form = document.querySelector('[data-glint-localization-form]');
  const contextNode = document.getElementById('GlintLocalizationContext');
  if (!form || !contextNode || !form.elements.language_code) return;
  const context = JSON.parse(contextNode.textContent);
  const languages = [...form.elements.language_code.options].map(option => option.value);
  if (languages.length < 2 || context.designMode || context.cartCount > 0 || context.locale !== 'en') return;
  const params = new URLSearchParams(location.search);
  if (params.has('preview_theme_id') || params.has('locale') || document.querySelector('#PBarNextFrame')) return;
  // A translated URL is an intentional entry from a link or search engine.
  if (/^\/[a-z]{2}(?:-[a-z]{2})?(?:\/|$)/i.test(location.pathname)) return;
  try {
    if (localStorage.getItem('glint-locale-choice') || sessionStorage.getItem('glint-locale-discovered')) return;
    sessionStorage.setItem('glint-locale-discovered', '1');
  } catch { return; }
  const controller = new AbortController();
  let interacted = false;
  const cancel = () => { interacted = true; controller.abort(); };
  const events = ['pointerdown', 'touchstart', 'keydown'];
  events.forEach(event => window.addEventListener(event, cancel, { once: true, passive: true }));
  const timeout = setTimeout(() => controller.abort(), 1800);
  try {
    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
      signal: controller.signal, headers: { Accept: 'application/json' }
    });
    if (!response.ok) return;
    const data = await response.json();
    const parts = data.suggestions?.[0]?.parts || {};
    const detectedCountry = data.detected_values?.country?.handle || parts.country?.handle || context.country;
    const countries = [...form.elements.country_code.options].map(option => option.value);
    const country = countries.includes(detectedCountry) ? detectedCountry : context.country;
    const browserLanguage = (navigator.languages?.[0] || navigator.language || '').split('-')[0].toLowerCase();
    // Use the destination for single-language markets; respect browser language
    // in multilingual countries. Explicit URLs and manual choices are kept above.
    const destinationLanguages = { FR: ['fr'], MC: ['fr'], NL: ['nl'], DE: ['de'], AT: ['de'], LI: ['de'], ES: ['es'], IT: ['it'], SM: ['it'], VA: ['it'], BE: ['nl', 'fr', 'de'], CH: ['de', 'fr', 'it'], LU: ['fr', 'de'] };
    const countryLanguages = destinationLanguages[country] || [];
    const preferred = countryLanguages.includes(browserLanguage) ? browserLanguage
      : countryLanguages.length === 1 ? countryLanguages[0]
      : languages.includes(browserLanguage) ? browserLanguage
      : languages.includes(parts.language?.handle) ? parts.language.handle
      : countryLanguages[0] || 'en';
    const language = languages.includes(preferred) ? preferred : context.locale;
    if (interacted || (language === context.locale && country === context.country)) return;
    form.elements.language_code.value = language;
    form.elements.country_code.value = country;
    keepCurrentPage(form);
    // submit() intentionally avoids storing an automatic discovery as a manual choice.
    HTMLFormElement.prototype.submit.call(form);
  } catch { /* Keep the current language and functional manual selector. */ }
  finally {
    clearTimeout(timeout);
    events.forEach(event => window.removeEventListener(event, cancel));
  }
})();
